<div class="container-amount my-1 py-3 px-2 rounded-2">
  <h5 class="px-2 pt-2">
    <i class="digi-out-euro"></i>
    {{ 'Doc::CustomerInvoice:AddPayment' | abpLocalization }}
  </h5>
  <div class="aside-body py-2">
    {{ ('Doc::RemainingAmount' | abpLocalization) + ' : ' + (remainingAmount | currency) }}
  </div>
  @if (originalRemainingAmount() > 0) {
    <form [formGroup]="form">
      @if (!hasPayments) {
        <div class="d-flex flex-wrap align-items-center gap-2 pt-1 pb-4">
          <div for="discount" class="form-label text-primary mb-0">
            {{ '::GlobalDiscount' | abpLocalization }}
          </div>
          <input
            #paymentInputRef
            class="form-control payment-input"
            formControlName="discount"
            suffix="%"
            mask="percent.2"
            (keydown.enter)="$event.preventDefault()"
          />
        </div>
      }
      <div class="payments-container" formArrayName="paymentMethods">
        @for (paymentMethod of paymentMethods.controls; let i = $index; track paymentMethod) {
          @if (paymentMethod) {
            <div [formGroupName]="$index" class="payments-container_item mb-2">
              <div class="d-flex flex-wrap align-items-center gap-2">
                <button
                  class="btn btn-outline p-1"
                  (keydown.enter)="$event.preventDefault()"
                  [class.btn-outline-primary]="paymentMethod.get('selected').value"
                  (click)="selectPayment(paymentMethod, paymentInputRef)"
                >
                  @if (paymentMethod.get('logo').value?.file) {
                    <img
                      [src]="paymentMethod.get('logo').value | fileUrl | async"
                      [title]="
                        paymentMethod.get('paymentMethodId').value
                          | displayName: paymentMethodEnumerationTypeStore.entities()
                      "
                    />
                  } @else {
                    {{
                      paymentMethod.get('paymentMethodId').value
                        | displayName: paymentMethodEnumerationTypeStore.entities()
                    }}
                  }
                </button>

                <input
                  #paymentInputRef
                  class="form-control"
                  type="number"
                  formControlName="amount"
                  (keydown.enter)="$event.preventDefault(); paymentAmountChanged(paymentMethod)"
                  (change)="paymentAmountChanged(paymentMethod)"
                />
              </div>
            </div>
          }
        }
      </div>
    </form>
    <div class="d-flex justify-content-end mt-3">
      <button
        type="submit"
        form="generalForm"
        class="btn btn-primary"
        [disabled]="!form.dirty"
        (click)="save()"
      >
        {{ '::ToValidate' | abpLocalization }}
      </button>
    </div>
  }
</div>
